import { createContext } from 'react';

//Types
export type NavDrawerContextType = {
    sidebarOpen: boolean
    sidebarCollapsed: string[]
    toggleSidebar: () => void
    setSidebarOpenState: (state: boolean) => void
}

const NavDrawerContext = createContext<NavDrawerContextType>({ sidebarOpen: false, toggleSidebar: () => { }, sidebarCollapsed: [], setSidebarOpenState: () => { }});
NavDrawerContext.displayName = 'NavDrawerContext';

export default NavDrawerContext
